const BUSINESS_TYPES = [
  {
    label: "Landbrugshandler / Gårdbutik",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Dyrehjem / Velgørenhed",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Baggrundsplads",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  { label: "Oksekødsproducent", value: "Beef Producer", id: "beef_producer" },
  { label: "Slagtekyllinger", value: "Broilers", id: "broilers" },
  { label: "Indkøbsgruppe", value: "Buying Group", id: "buying_group" },
  { label: "Kalveproduktion", value: "Calf Production", id: "calf_production" },
  {
    label: "Kalvegård/Udvikler",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Kvægkøber", value: "Cattle Buyer", id: "cattle_buyer" },
  { label: "Kontraktdyrker", value: "Contract Grower", id: "contract_grower" },
  { label: "Andelsselskab", value: "Cooperative", id: "cooperative" },
  { label: "Hovedkontor", value: "Corporate Office", id: "corporate_office" },
  {
    label: "Ko/Kalv-drift",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Mælkeproduktion",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributør / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Fodermølle", value: "Feed Mill", id: "feed_mill" },
  { label: "Fodergård", value: "Feedyard", id: "feedyard" },
  {
    label: "Dyrker/Dyrkergård",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Rugemaskine", value: "Hatchery", id: "hatchery" },
  {
    label: "Kvieproduktion",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Ægproduktion Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Ægproducerende høns", value: "Layers", id: "layers" },
  { label: "Medier", value: "Media", id: "media" },
  {
    label: "Mælkeandelsselskab/Køberen",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Blandet/An den producent",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Næringsstoflevérandør",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Pakker/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Kæledyrsbutik",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apotek", value: "Pharmacy", id: "pharmacy" },
  { label: "Fjerkræavler", value: "Poultry Breeder", id: "poultry_breeder" },
  {
    label: "Fjerkræintegrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Fåreproducent", value: "Sheep Producer", id: "sheep_producer" },
  { label: "Ungdyrdrift", value: "Stocker Operation", id: "stocker_operation" },
  {
    label: "Kvæggård/Salgsstald",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Svineproducent", value: "Swine Producer", id: "swine_producer" },
  { label: "Kalkuner", value: "Turkeys", id: "turkeys" },
  {
    label: "Universitet / Uddannelse",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinærpraksis",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Grossist / Detailhandler",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Uldkøber", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: { errors: { required: "Påkrævet" } },
  salutation: {
    label: "Tiltaleform",
    placeholder: "Vælg tiltaleform",
    errors: {
      required: "Tiltaleform er påkrævet",
      invalid: "Vælg en gyldig tiltaleform",
    },
  },
  firstName: {
    label: "Fornavn",
    placeholder: "John",
    errors: {
      authenticatedNameUpdateTrial:
        "Du er logget ind, og dit navn kan ikke ændres.",
      required: "Fornavn er påkrævet",
      minLength: "Fornavn skal være mindst 2 tegn",
      maxLength: "Fornavn må højst være 50 tegn",
    },
  },
  lastName: {
    label: "Efternavn",
    placeholder: "Doe",
    errors: {
      authenticatedNameUpdateTrial:
        "Du er logget ind, og dit navn kan ikke ændres.",
      required: "Efternavn er påkrævet",
      minLength: "Efternavn skal være mindst 2 tegn",
      maxLength: "Efternavn må højst være 50 tegn",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "john.smith@example.org",
    description:
      "Indtast venligst en e-mailadresse, der er personlig for dig, ikke en delt e-mailadresse.",
    prefixWarningTitle: "Delt postkasse opdaget",
    prefixWarningDescription:
      "Vi anbefaler at bruge en personlig e-mailadresse for en bedre personlig oplevelse",
    errors: {
      authenticatedEmailUpdateTrial:
        "Du er logget ind, og din e-mailadresse kan ikke ændres.",
      required: "E-mail er påkrævet",
      invalidEmail: "Indtast venligst en gyldig e-mailadresse",
      emailAssociatedWithYourAccount:
        "Din e-mailadresse er knyttet til din konto og kan ikke ændres.",
    },
  },
  confirmEmail: {
    label: "Bekræft e-mail",
    placeholder: "john.smith@example.org",
    errors: {
      authenticatedEmailUpdateTrial:
        "Du er logget ind, og din e-mailadresse kan ikke ændres.",
      required: "Bekræft e-mail er påkrævet",
      invalidEmail: "Indtast venligst en gyldig e-mailadresse",
      emailMatchError: "E-mailadresserne stemmer ikke overens",
    },
  },
  password: {
    label: "Adgangskode",
    placeholder: "Indtast din adgangskode",
    errors: { required: "Adgangskode er påkrævet" },
  },
  confirmPassword: {
    label: "Bekræft adgangskode",
    placeholder: "Bekræft din adgangskode",
    errors: {
      required: "Bekræft adgangskode er påkrævet",
      passwordMatchError: "Adgangskoderne stemmer ikke overens",
    },
  },
  addressLine1: {
    label: "Adresselinje 1",
    placeholder: "123 Main St",
    errors: {
      required: "Adresselinje 1 er påkrævet",
      minLength: "Adresselinje 1 skal være mindst 5 tegn",
      maxLength: "Adresselinje 1 må højst være 100 tegn",
    },
  },
  addressLine2: {
    label: "Adresselinje 2",
    placeholder: "Lejl 4B",
    errors: {
      required: "Adresselinje 2 er påkrævet",
      maxLength: "Adresselinje 2 må højst være 100 tegn",
    },
  },
  city: {
    label: "By",
    placeholder: "København",
    errors: {
      required: "By er påkrævet",
      minLength: "By skal være mindst 2 tegn",
      maxLength: "By må højst være 50 tegn",
    },
  },
  country: {
    label: "Land",
    placeholder: "Vælg land",
    errors: {
      required: "Land er påkrævet",
      invalid: "Vælg venligst et gyldigt land",
    },
  },
  state: {
    label: "Region",
    placeholder: "Vælg region",
    errors: {
      required: "Region er påkrævet",
      invalid: "Vælg en gyldig region",
    },
  },
  jurisdiction: {
    label: "Licensjurisdiktion",
    placeholder: "Vælg licensjurisdiktion",
    errors: {
      required: "Licensjurisdiktion er påkrævet",
      invalid: "Vælg en gyldig jurisdiktion",
    },
  },
  zipCode: {
    label: "Postnummer",
    placeholder: "12345",
    errors: {
      required: "Postnummer er påkrævet",
      invalid: "Indtast venligst et gyldigt postnummer",
    },
  },
  role: {
    label: "Rolle",
    placeholder: "Vælg din rolle",
    errors: {
      required: "Vælg venligst din rolle",
      invalid: "Vælg en gyldig rolle",
    },
  },
  businessType: {
    label: "Virksomhedstype",
    placeholder: "Vælg virksomhedstype",
    errors: {
      required: "Virksomhedstype er påkrævet",
      invalid: "Vælg en gyldig virksomhedstype",
    },
  },
  businessName: {
    label: "Virksomhedsnavn",
    placeholder: "Indtast virksomhedsnavn",
    errors: {
      required: "Virksomhedsnavn er påkrævet",
      minLength: "Virksomhedsnavn skal være mindst 2 tegn",
      maxLength: "Virksomhedsnavn må højst være 100 tegn",
    },
  },
  businessSearch: {
    label: "Virksomhedssøgning:",
    addNewAccount: "Tilføj ny virksomhedskonto",
    canNotFindBusiness: "Kan du ikke finde din virksomhed?",
    guideline:
      "Indtast venligst dit postnummer, og vælg derefter fra listen nedenfor.",
    guidelineForNameSearch:
      "Indtast venligst fuldt virksomhedsnavn, og vælg derefter fra listen.",
    placeholder: "Hvor arbejder du?",
    noResults: "Ingen resultater fundet",
    searching: "Søger...",
    selectedBusinessHeading: "Valgt virksomhed:",
    selectedBusinessNotCorrect: "Ikke korrekt?",
    selectedBusinessTryAgain: "Prøv igen",
    selectedBusinessDismiss: "Afvis virksomhed",
    resultsFound: {
      singular: "1 virksomhed fundet",
      plural: "Flere virksomheder fundet",
    },
    errors: {
      network:
        "Vi har problemer med at oprette forbindelse til virksomhedssøgeren. Prøv venligst igen senere.",
    },
  },
  explicitConsent: {
    label:
      "Ved at markere dette felt accepterer jeg at modtage markedsføringskommunikation fra Elanco.",
    errors: { required: "Samtykke er påkrævet" },
  },
  explicitSmsConsent: {
    label:
      "Ved at markere dette felt accepterer jeg at modtage markedsføringskommunikation fra Elanco via SMS/tekstbesked.",
    errors: {
      required: "Samtykke til SMS er påkrævet",
    },
  },
  telephone: {
    label: "Personligt telefonnummer",
    placeholder: "Indtast dit personlige telefonnummer",
    dialCodeLabel: "Kode",
    dialCodePlaceholder: "Søg land…",
    errors: { invalid: "Indtast venligst et gyldigt telefonnummer." },
  },
  businessTelephone: {
    label: "Virksomhedstelefon",
    placeholder: "Indtast dit virksomhedstelefonnummer",
    dialCodeLabel: "Kode",
    dialCodePlaceholder: "Søg land…",
    errors: { invalid: "Indtast venligst et gyldigt telefonnummer." },
  },
  professionalNumber: {
    label: "Professionelt nummer",
    placeholder: "1234567",
    errors: {
      required: "Indtast venligst et professionelt nummer",
      maxLength: "Indtastningen overskrider tegngrænsen",
    },
  },
  addressSearch: { errors: { required: "Dette felt er påkrævet" } },
  businessSearchField: { errors: { required: "Dette felt er påkrævet" } },
  checkbox: { errors: { required: "Dette felt er påkrævet" } },
  checkboxGroup: { errors: { required: "Dette felt er påkrævet" } },
  combobox: { errors: { required: "Dette felt er påkrævet" } },
  datePicker: { errors: { required: "Dette felt er påkrævet" } },
  dateRange: { errors: { required: "Dette felt er påkrævet" } },
  dateTime: { errors: { required: "Dette felt er påkrævet" } },
  emailField: { errors: { required: "Dette felt er påkrævet" } },
  fileInput: { errors: { required: "Vælg venligst en fil" } },
  number: {
    errors: {
      required: "Indtast venligst et tal",
      minValue: "Indtast venligst en værdi højere end minimum",
      maxValue: "Indtast venligst en værdi lavere end maksimum",
    },
  },
  passwordField: { errors: { required: "Dette felt er påkrævet" } },
  rangeSlider: { errors: { required: "Dette felt er påkrævet" } },
  select: { errors: { required: "Dette felt er påkrævet" } },
  telephoneField: {
    errors: {
      required: "Indtast venligst kun tal",
      invalidTelephone: "Indtast venligst gyldigt telefonnummer",
      invalidFormat: "Ugyldigt nummerformat",
    },
  },
  text: {
    errors: {
      required:
        "Brug venligst kun bogstaver (A-Å), tal (0-9) og ingen symboler",
      maxLength: "Indtastningen overskrider tegngrænsen",
      minLength: "Indtastningen skal være mindst 2 tegn",
    },
  },
  textarea: { characters: "tegn" },
  time: { errors: { required: "Dette felt er påkrævet" } },
  form: {
    errors: {
      generic:
        "Vi stødte på en fejl ved indsendelse af din formular. Prøv venligst igen.",
      reportAnIssue: "Rapporter venligst et problem.",
      configuration: "Konfigurationsfejl",
      noFormQuestionsAvailable: "Ingen formularspørgsmål tilgængelige.",
      formComponentLoad:
        "Formularkomponent kunne ikke indlæses på grund af et ikke-understøttet felt.",
      code: "Kode",
      type: "Type",
      missingRequiredFields:
        "Denne formular mangler påkrævede felter (e-mail og/eller samtykke). Kontakt venligst en administrator for at rette formularkonfigurationen.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Akademiker", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Dyrevelfærd - Andet",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Dyrevelfærd - Butikspersonale",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Dyrevelfærd - Dyrlæge",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Dyrevelfærd - Dyrlægesygeplejerske",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Dyrevelfærd - Frivillig",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Oksekød / Fodergård udvidelse",
    id: "beef_feedlot_extension",
  },
  { value: "Beef Producer", label: "Oksekødsproducent", id: "beef_producer" },
  { value: "Breeder", label: "Opdrætter", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Virksomhedsadministrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Virksomhedsejer / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Konsulerende ernæringsfysiolog",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Virksomhedsvæetrinæransat (ikke-hospital)",
    id: "corporate_employee_non_dvm",
  },
  { value: "Dairy Producer", label: "Mælkeproducent", id: "dairy_producer" },
  { value: "Distributor", label: "Distributør", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributørrepræsentant, feltbaseret",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributørrepræsentant, intern",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Uddannelsesinstitution - Gymnasieelev",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Uddannelsesinstitution - Fagskole studerende",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Uddannelsesinstitution - Universitetsstuderende",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medicinsk/Klinik direktør",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Ernæring / Fodersalg",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Ernæringsprofessionel",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Ernæringsfysiolog", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Kontor/Praksisleder",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC-detailhandler", id: "otc_retailer" },
  { value: "Pharmacist", label: "Apoteker", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apotek - Personale",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Svineproducent", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Fjerkræproducent",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Praksisejer, ikke dyrlæge",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Kundeservice",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Forhandlerbutik - Personale",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Producent - Blandet/Andet",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Detailhandler",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Fåreproducent",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Dyrlæge",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Træner", id: "trainer" },
  { value: "Veterinarian", label: "Dyrlæge", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Dyrlæge, praksisejer",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Dyrlægeassistent",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Dyrlægesygeplejerske",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinærpraksis - Andet",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinærpraksis - Dyrlæge",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinærpraksis - Dyrlægesygeplejerske",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinærspecialist",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinærstuderende",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinærkirurg",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinærtekniker",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Grossist", id: "wholesaler" },
];

const SALUTATIONS = [
  { label: "Dr.", value: "Dr.", id: "dr" },
  { label: "M.", value: "M.", id: "m" },
  { label: "Frøken", value: "Miss", id: "miss" },
  { label: "Hr.", value: "Mr.", id: "mr" },
  { label: "Fru", value: "Mrs.", id: "mrs" },
  { label: "Fru/Frøken", value: "Ms.", id: "ms" },
  { label: "Mx.", value: "Mx.", id: "mx" },
  { label: "Professor", value: "Professor", id: "professor" },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
